import React from 'react';
import CustomImage from '../../../components/custom-image';

const Power = () => {
  return (
    <div className="card">
      <div className="title">
        <div className="icon">
          <CustomImage className="custom-image" imageName="icon-power-lg.png" alt="Power" maxWidth="90" />
        </div>
        <div className="text">
          <h4>Power</h4>
        </div>
      </div>
      <div className="middle-text">
        <h3 className="green-text">9GW</h3>
        <p>
          diversified power
          <br /> portfolio
        </p>
      </div>
      <div className="bottom-text">
        <p>EBITDA (In INR Cr.)</p>
        <p className="green-text">1,649</p>
      </div>
    </div>
  );
};

export default Power;
